import { render } from "./PollCard.vue?vue&type=template&id=6f298514&scoped=true"
import script from "./PollCard.vue?vue&type=script&lang=js"
export * from "./PollCard.vue?vue&type=script&lang=js"

import "./PollCard.vue?vue&type=style&index=0&id=6f298514&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f298514"]])

export default __exports__